import { loadedScriptsCache } from './scriptLoaderCache';
import type { LoadScriptsAsyncReturnType, ScriptSource } from './types';

export async function loadScriptsAsync(scriptSources: ScriptSource[]): Promise<LoadScriptsAsyncReturnType> {
    const scriptPromises = scriptSources.map((source) => {
        const cacheKey = source.url || source.id;

        return new Promise<ScriptSource>((resolve, reject) => {
            if (cacheKey && loadedScriptsCache.has(cacheKey)) {
                console.warn(`Script already loaded: ${cacheKey}`);
                resolve(source);
                return;
            }

            if (source.url) {
                const scriptTag = document.createElement('script');
                scriptTag.src = source.url;
                scriptTag.async = true;
                scriptTag.onload = () => {
                    loadedScriptsCache.add(source.url as string);
                    resolve(source);
                };
                scriptTag.onerror = () => reject(new Error(`Failed to load script: ${source.url}`));
                document.head.appendChild(scriptTag);
            } else if (source.code && source.id) {
                const scriptTag = document.createElement('script');
                scriptTag.textContent = source.code;
                scriptTag.id = source.id;
                scriptTag.async = true;
                document.head.appendChild(scriptTag);
                loadedScriptsCache.add(source.id as string);
                resolve(source);
            } else {
                reject(new Error('Invalid script source. A URL or both code and id must be provided'));
            }
        });
    });

    const results = await Promise.allSettled(scriptPromises);

    const scriptsLoaded = true;
    const scriptsLoadSuccess = results.every(result => result.status === 'fulfilled');

    return {
        scriptsLoaded,
        scriptsLoadSuccess
    };
}